import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms';

interface BoxSkeletonProps {
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const BoxSkeleton: React.FunctionComponent<BoxSkeletonProps> = function ({ sx = {} }) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                ...sx,
            }}
        >
            <BoxBone sx={{ width: '100%', height: '100%' }} />
        </Box>
    );
};
